import React, { useContext, useState } from 'react'
import { NavLink, Link } from 'react-router-dom'
import AuthContext from '../context/AuthContext'
import Dashboard from '../assets/images/sidebar_icon1.svg'
import employeeRequest from '../assets/icons/employee-request.svg'
import totalAccepted from '../assets/icons/accepted-employee.svg'
import HROnboarding from '../assets/icons/Hr-onboarding.svg'
import accountantOnboarding from '../assets/icons/accountant-onboarding.svg'
import departmentManager from '../assets/icons/department-manager.svg'
import skillManager from '../assets/icons/skill-manager.svg'
import manageJobs from '../assets/icons/manage-jobs.svg'
import biomatricModule from '../assets/icons/biometric-module.svg'
import FormsManager from '../assets/icons/forms-manager.svg'
import leavesManager from '../assets/icons/Leaves-manager.svg'
import support from '../assets/icons/support.svg'
import OImage from './reusable/OImage'
import Notification from '../assets/images/notification_manager.svg'
import Logout from '../assets/images/logout.svg'
import { useTranslation } from 'react-i18next'
// --- React Icons ---
import {
  FaChevronDown,
  FaChevronRight,
  FaUserPlus,
  FaUsers,
  FaCogs,
  FaBullhorn,
  FaHandshake,
  FaMoneyCheckAlt
} from 'react-icons/fa'
import { GitBranch } from "lucide-react";
import { MdViewKanban } from "react-icons/md";
import {
  HiUsers,
  HiBuildingOffice2,
} from "react-icons/hi2";
import {
  LuInbox,
  LuCalendarCheck,
} from "react-icons/lu";

const classNames = require('classnames')

const Sidebar = () => {
  const { t } = useTranslation()

  // 👇 CHANGED: also read Pipedrive connection state from AuthContext
  const {
    user,
    sidebarStatus,
    updatePageName,
    logoutUser,
    pipedriveConnected,      // 👈 CHANGED
    pipedriveStatusLoading,  // 👈 CHANGED
  } = useContext(AuthContext)

  const [openMenus, setOpenMenus] = useState({})

  const toggleMenu = (menuKey) => {
    setOpenMenus(prev => ({
      ...prev,
      [menuKey]: !prev[menuKey]
    }))
  }

  const getNavLinkClassName = isActive =>
    classNames(
      'flex items-center px-4 lg:px-7 py-3 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue transition-colors duration-200',
      { active: isActive }
    )

  const handleLogout = () => {
    if (window.confirm('Are you sure to logout?')) {
      logoutUser()
    }
  }

  // ---------------------------------------------------------
  // 1. UNIFIED MENU CONFIGURATION
  // Items without an `items` array will automatically render as standalone links.
  // ---------------------------------------------------------
  const menuConfig = [
    // Standalone Dashboard
    {
      key: 'dashboard',
      isStandalone: true,
      label: t('NAV_DASHBOARD'),
      path: '/dashboard',
      icon: <img className='max-w-[18px]' src={Dashboard} alt='' />
    },
    // Hire Dropdown
    {
      key: 'hire',
      label: 'HIRE',
      icon: <FaUserPlus className="text-lg" />,
      items: [
        { label: t('EMPLOYEE_REQUEST_FOR_JOB'), path: '/job_request', icon: employeeRequest }
      ]
    },
    // People Dropdown
    {
      key: 'people',
      label: 'PEOPLE',
      icon: <FaUsers className="text-lg" />,
      items: [
        { label: t('TOTAL_ACCEPTED_EMPLOYEES'), path: '/all-employees', icon: totalAccepted },
        { label: t('HR_ONBOARDING'), path: '/HR-onboarding', icon: HROnboarding },
        { label: t('ACCOUNTANT_ONBOARDING'), path: '/accountant-onboarding', icon: accountantOnboarding },
      ]
    },
    // Operations Dropdown
    {
      key: 'operations',
      label: 'OPERATIONS',
      icon: <FaCogs className="text-lg" />,
      items: [
        { label: t('DEPARTMENT_MANAGER'), path: '/department_manager', icon: departmentManager },
        { label: t('SKILL_MANAGER'), path: '/skill_manager', icon: skillManager },
        { label: t('MANAGE_JOBS'), path: '/manage-jobs', icon: manageJobs },
        { label: t('FORMS_MANAGER'), path: '/forms_manager', icon: FormsManager },
        { label: t('SUGGESTED_FORMS'), path: '/suggested_forms', icon: FormsManager },
      ]
    },
    // Standalone Payroll (Placed exactly where you want it)
    {
      key: 'payroll',
      isStandalone: true,
      label: t('PAYROLL_ONBOARDING'),
      path: '/payroll-onboarding',
      icon: <FaMoneyCheckAlt className="text-lg" />
    },
    // Communications Dropdown
    {
      key: 'communications',
      label: 'COMMUNICATIONS',
      icon: <FaBullhorn className="text-lg" />,
      items: [
        { label: t('NOTIFICATION_MANAGER'), path: '/notification_manager', icon: Notification },
        { label: t('SUPPORT'), path: '/support', icon: support }
      ]
    },
    // Pipedrive Dropdown
    {
      key: 'PIPEDRIVE',
      label: 'PIPEDRIVE CRM',
      icon: <FaHandshake className="text-lg" />,
      items: [
        { label: t('CONNECTIONS'), path: '/pipedrive-connection', icon: GitBranch },

        // 👇 CHANGED: only show Leads Inbox + Deals Pipeline when connected
        ...((!pipedriveStatusLoading && pipedriveConnected)
          ? [
              { label: t('LEADS_INBOX'), path: '/pipedrive/leads-inbox', icon: LuInbox },
              { label: t('DEAL_PIPELINE'), path: '/pipedrive/deal-pipeline', icon: MdViewKanban },
            ]
          : []),
      ]
    }
  ]

  return (
    <>
      <div
        className={`sidebar lg:block z-10 ${sidebarStatus === 'close' ? 'hideSideBar' : 'block'
          } bg-gradient-to-t from-gradpurple to-gradblue w-[220px] xl:w-[280px] fixed h-full overflow-y-auto`}
      >
        <div className='text-white'>

          {/* Profile Section */}
          <div className='text-center profile py-6'>
            <figure className='inline-block overflow-hidden rounded-full border-lightpurple mb-2.5'>
              <OImage
                src={user?.profilePicture}
                fallbackUrl='/images/user.png'
                className='w-20 h-20'
              />
            </figure>
            <small className='block text-sm'>Welcome</small>
            <strong className='block text-ellipsis text-lg overflow-hidden px-2 whitespace-nowrap '>
              {user?.name}
            </strong>
          </div>

          <nav className='flex flex-col pt-4 pb-5 justify-center font-normal text-xs'>

            {/* RENDER MENU */}
            {menuConfig.map((category) => {
              // 1. IF STANDALONE: Render a direct NavLink wrapped in a div for the border
              if (category.isStandalone) {
                return (
                  <div key={category.key} className="border-b border-white/10 last:border-0">
                    <NavLink
                      to={category.path}
                      className={({ isActive }) => getNavLinkClassName(isActive)}
                      onClick={() => updatePageName(category.label)}
                    >
                      <span className='mr-3 flex items-center justify-center w-5 h-5'>
                        {category.icon}
                      </span>
                      <span className="whitespace-nowrap font-medium tracking-wide uppercase text-xs">
                        {category.label}
                      </span>
                    </NavLink>
                  </div>
                );
              }

              // 2. IF DROPDOWN: Render the accordion
              return (
                <div key={category.key} className="border-b border-white/10 last:border-0">
                  {/* Parent Header */}
                  <button
                    onClick={() => toggleMenu(category.key)}
                    className="w-full text-left px-4 lg:px-7 py-3.5 text-white flex items-center justify-between hover:bg-white/10 transition-colors duration-200 focus:outline-none"
                  >
                    <div className="flex items-center gap-3">
                      <span className="flex items-center justify-center w-5 h-5 text-white">
                        {category.icon}
                      </span>
                      <span className='font-medium tracking-wide uppercase text-xs'>{category.label}</span>
                    </div>
                    <span className='text-xs text-white/70'>
                      {openMenus[category.key] ? <FaChevronDown /> : <FaChevronRight />}
                    </span>
                  </button>

                  {/* Sub-items */}
                  {openMenus[category.key] && (
                    <div className="flex flex-col pb-1">
                      {category.items.map((item, index) => (
                        <NavLink
                          key={index}
                          to={item.path}
                          onClick={() => updatePageName(item.label)}
                          className={({ isActive }) => classNames(
                            'flex items-center py-2.5 pr-4 text-white hover:bg-white hover:text-LightBlue transition-colors duration-200',
                            'pl-[2.5rem] lg:pl-[3.5rem]'
                          )}
                        >
                          <span className="mr-3 flex-shrink-0 flex items-center justify-center w-5 h-5">
                            {typeof item.icon === 'string' ? (
                              <img
                                className="w-4 h-4 object-contain"
                                src={item.icon}
                                alt=""
                              />
                            ) : (
                              React.createElement(item.icon, {
                                size: 18,
                                className: "shrink-0",
                              })
                            )}
                          </span>
                          <span className="whitespace-nowrap">{item.label}</span>
                        </NavLink>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}

            {/* LOGOUT */}
            <Link
              onClick={handleLogout}
              className='flex items-center px-4 lg:px-7 py-4 text-white hover:bg-white hover:text-LightBlue transition-colors duration-200 mt-2'
            >
              <span className='mr-3'>
                <img className='max-w-[18px]' src={Logout} alt='logout' />
              </span>
              {t('NAV_LOGOUT') || 'Logout'}
            </Link>
          </nav>
        </div>
      </div>
    </>
  )
}

export default Sidebar





// import React, { useContext, useState } from 'react'
// import { NavLink, Link } from 'react-router-dom'
// import AuthContext from '../context/AuthContext'
// // --- Your Original Imports ---
// import Dashboard from '../assets/images/sidebar_icon1.svg'
// import employeeRequest from '../assets/icons/employee-request.svg'
// import totalAccepted from '../assets/icons/accepted-employee.svg'
// import HROnboarding from '../assets/icons/Hr-onboarding.svg'
// import accountantOnboarding from '../assets/icons/accountant-onboarding.svg'
// import departmentManager from '../assets/icons/department-manager.svg'
// import skillManager from '../assets/icons/skill-manager.svg'
// import manageJobs from '../assets/icons/manage-jobs.svg'
// import biomatricModule from '../assets/icons/biometric-module.svg'
// import FormsManager from '../assets/icons/forms-manager.svg'
// import leavesManager from '../assets/icons/Leaves-manager.svg'
// import support from '../assets/icons/support.svg'
// import OImage from './reusable/OImage'
// import Notification from '../assets/images/notification_manager.svg'
// import Logout from '../assets/images/logout.svg'
// import { useTranslation } from 'react-i18next'
// // --- React Icons ---
// import {
//   FaChevronDown,
//   FaChevronRight,
//   FaUserPlus,
//   FaUsers,
//   FaCogs,
//   FaBullhorn,
//   FaHandshake,
//   FaMoneyCheckAlt
// } from 'react-icons/fa'
// import { GitBranch } from "lucide-react";
// import { MdViewKanban } from "react-icons/md";
// import {
//   HiUsers,
//   HiBuildingOffice2,
// } from "react-icons/hi2";
// import {
//   LuInbox,
//   LuCalendarCheck,
// } from "react-icons/lu";

// const classNames = require('classnames')

// const Sidebar = () => {
//   const { t } = useTranslation()
//   const { user, sidebarStatus, updatePageName, logoutUser } = useContext(AuthContext)

//   const [openMenus, setOpenMenus] = useState({})

//   const toggleMenu = (menuKey) => {
//     setOpenMenus(prev => ({
//       ...prev,
//       [menuKey]: !prev[menuKey]
//     }))
//   }

//   const getNavLinkClassName = isActive =>
//     classNames(
//       'flex items-center px-4 lg:px-7 py-3 text-white active:text-LightBlue hover:bg-white hover:text-LightBlue transition-colors duration-200',
//       { active: isActive }
//     )

//   const handleLogout = () => {
//     if (window.confirm('Are you sure to logout?')) {
//       logoutUser()
//     }
//   }

//   // ---------------------------------------------------------
//   // 1. UNIFIED MENU CONFIGURATION
//   // Items without an `items` array will automatically render as standalone links.
//   // ---------------------------------------------------------
//   const menuConfig = [
//     // Standalone Dashboard
//     {
//       key: 'dashboard',
//       isStandalone: true,
//       label: t('NAV_DASHBOARD'),
//       path: '/dashboard',
//       icon: <img className='max-w-[18px]' src={Dashboard} alt='' />
//     },
//     // Hire Dropdown
//     {
//       key: 'hire',
//       label: 'HIRE',
//       icon: <FaUserPlus className="text-lg" />,
//       items: [
//         { label: t('EMPLOYEE_REQUEST_FOR_JOB'), path: '/job_request', icon: employeeRequest }
//       ]
//     },
//     // People Dropdown
//     {
//       key: 'people',
//       label: 'PEOPLE',
//       icon: <FaUsers className="text-lg" />,
//       items: [
//         { label: t('TOTAL_ACCEPTED_EMPLOYEES'), path: '/all-employees', icon: totalAccepted },
//         { label: t('HR_ONBOARDING'), path: '/HR-onboarding', icon: HROnboarding },
//         { label: t('ACCOUNTANT_ONBOARDING'), path: '/accountant-onboarding', icon: accountantOnboarding },
//       ]
//     },
//     // Operations Dropdown
//     {
//       key: 'operations',
//       label: 'OPERATIONS',
//       icon: <FaCogs className="text-lg" />,
//       items: [
//         { label: t('DEPARTMENT_MANAGER'), path: '/department_manager', icon: departmentManager },
//         { label: t('SKILL_MANAGER'), path: '/skill_manager', icon: skillManager },
//         { label: t('MANAGE_JOBS'), path: '/manage-jobs', icon: manageJobs },
//         { label: t('FORMS_MANAGER'), path: '/forms_manager', icon: FormsManager },
//         { label: t('SUGGESTED_FORMS'), path: '/suggested_forms', icon: FormsManager },
//       ]
//     },
//     // Standalone Payroll (Placed exactly where you want it)
//     {
//       key: 'payroll',
//       isStandalone: true,
//       label: t('PAYROLL_ONBOARDING'),
//       path: '/payroll-onboarding',
//       icon: <FaMoneyCheckAlt className="text-lg" />
//     },
//     // Communications Dropdown
//     {
//       key: 'communications',
//       label: 'COMMUNICATIONS',
//       icon: <FaBullhorn className="text-lg" />,
//       items: [
//         { label: t('NOTIFICATION_MANAGER'), path: '/notification_manager', icon: Notification },
//         { label: t('SUPPORT'), path: '/support', icon: support }
//       ]
//     },
//     // Pipedrive Dropdown
//     {
//       key: 'PIPEDRIVE',
//       label: 'PIPEDRIVE CRM',
//       icon: <FaHandshake className="text-lg" />,
//       items: [
//         { label: t('CONNECTIONS'), path: '/pipedrive-connection', icon: GitBranch },
//         { label: t('LEADS_INBOX'), path: '/pipedrive/leads-inbox', icon: LuInbox },
//         { label: t('DEAL_PIPELINE'), path: '/pipedrive/deal-pipeline', icon: MdViewKanban },
//       ]
//     }
//   ]

//   return (
//     <>
//       <div
//         className={`sidebar lg:block z-10 ${sidebarStatus === 'close' ? 'hideSideBar' : 'block'
//           } bg-gradient-to-t from-gradpurple to-gradblue w-[220px] xl:w-[280px] fixed h-full overflow-y-auto`}
//       >
//         <div className='text-white'>

//           {/* Profile Section */}
//           <div className='text-center profile py-6'>
//             <figure className='inline-block overflow-hidden rounded-full border-lightpurple mb-2.5'>
//               <OImage
//                 src={user?.profilePicture === "https://d2n5q7sk1gggpw.cloudfront.net/no_image.png" ? '/images/No-image-found.jpg': user?.profilePicture }
//                 className='w-20 h-20'
//               />
//             </figure>
//             <small className='block text-sm'>Welcome</small>
//             <strong className='block text-ellipsis text-lg overflow-hidden px-2 whitespace-nowrap '>
//               {user?.name}
//             </strong>
//           </div>

//           <nav className='flex flex-col pt-4 pb-5 justify-center font-normal text-xs'>

//             {/* RENDER MENU */}
//             {menuConfig.map((category) => {
//               // 1. IF STANDALONE: Render a direct NavLink wrapped in a div for the border
//               if (category.isStandalone) {
//                 return (
//                   <div key={category.key} className="border-b border-white/10 last:border-0">
//                     <NavLink
//                       to={category.path}
//                       className={({ isActive }) => getNavLinkClassName(isActive)}
//                       onClick={() => updatePageName(category.label)}
//                     >
//                       <span className='mr-3 flex items-center justify-center w-5 h-5'>
//                         {category.icon}
//                       </span>
//                       <span className="whitespace-nowrap font-medium tracking-wide uppercase text-xs">
//                         {category.label}
//                       </span>
//                     </NavLink>
//                   </div>
//                 );
//               }

//               // 2. IF DROPDOWN: Render the accordion
//               return (
//                 <div key={category.key} className="border-b border-white/10 last:border-0">
//                   {/* Parent Header */}
//                   <button
//                     onClick={() => toggleMenu(category.key)}
//                     className="w-full text-left px-4 lg:px-7 py-3.5 text-white flex items-center justify-between hover:bg-white/10 transition-colors duration-200 focus:outline-none"
//                   >
//                     <div className="flex items-center gap-3">
//                       <span className="flex items-center justify-center w-5 h-5 text-white">
//                         {category.icon}
//                       </span>
//                       <span className='font-medium tracking-wide uppercase text-xs'>{category.label}</span>
//                     </div>
//                     <span className='text-xs text-white/70'>
//                       {openMenus[category.key] ? <FaChevronDown /> : <FaChevronRight />}
//                     </span>
//                   </button>

//                   {/* Sub-items */}
//                   {openMenus[category.key] && (
//                     <div className="flex flex-col pb-1">
//                       {category.items.map((item, index) => (
//                         <NavLink
//                           key={index}
//                           to={item.path}
//                           onClick={() => updatePageName(item.label)}
//                           className={({ isActive }) => classNames(
//                             'flex items-center py-2.5 pr-4 text-white hover:bg-white hover:text-LightBlue transition-colors duration-200',
//                             'pl-[2.5rem] lg:pl-[3.5rem]'
//                           )}
//                         >
//                           <span className="mr-3 flex-shrink-0 flex items-center justify-center w-5 h-5">
//                             {typeof item.icon === 'string' ? (
//                               <img
//                                 className="w-4 h-4 object-contain"
//                                 src={item.icon}
//                                 alt=""
//                               />
//                             ) : (
//                               React.createElement(item.icon, {
//                                 size: 18,
//                                 className: "shrink-0",
//                               })
//                             )}
//                           </span>
//                           <span className="whitespace-nowrap">{item.label}</span>
//                         </NavLink>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               );
//             })}

//             {/* LOGOUT */}
//             <Link
//               onClick={handleLogout}
//               className='flex items-center px-4 lg:px-7 py-4 text-white hover:bg-white hover:text-LightBlue transition-colors duration-200 mt-2'
//             >
//               <span className='mr-3'>
//                 <img className='max-w-[18px]' src={Logout} alt='logout' />
//               </span>
//               {t('NAV_LOGOUT') || 'Logout'}
//             </Link>
//           </nav>
//         </div>
//       </div>
//     </>
//   )
// }

// export default Sidebar